<template>
  <div class="content">
    <div class="content_title">
      Связь групп доступа и типов пользователей
    </div>
    <div
      class="content_row"
      v-for="(parsecGroup, key) in parsecGroups"
      :key="key"
    >
      <div>
        {{ parsecGroup.NAME }}
      </div>
      <div>
        <select v-model="parsecGroup.TYPE" @change="updateGroup(parsecGroup)">
          <option value=""></option>
          <option value="owner">Собственники</option>
          <option value="guest">Гости</option>
          <option value="truck">Грузовики</option>
        </select>
      </div>
      <div>
        <button @click="deleteParsecGroup(parsecGroup.ID)">
          Удалить группу
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "ParsecAccessTypesLink",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      access_group_filter: "",
      village_filter: "",
      parsecGroups: [],
      villages: [],
      checkedGroups: [],
      checkedVillages: [],
      login: "",
      password: "",
      server_ip: "",
      data_loaded: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    getGroupsData: function() {
      let self = this;
      let user = this.$store.getters["user/getProfile"];
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/get/",
          filter: { USER: user.id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.parsecGroups = data;
          }
        });
    },
    updateGroup: function(group) {
      let self = this;
      let updateData = group;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/update/",
          data: updateData,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
        });
    },
    deleteParsecGroup: function(group_id) {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/delete/",
          data: { ID: group_id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.getGroupsData();
        });
    }
  },
  created() {
    this.getGroupsData();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
